<script setup>
import InputLabel from '@/Components/InputLabel.vue';
import TextInput from '@/Components/TextInput.vue';
import { Head, Link, useForm } from '@inertiajs/vue3';
import SimpleLayout from '@/Layouts/SimpleLayout.vue';
import Checkbox from '@/Components/Checkbox.vue';

defineOptions({
    layout: SimpleLayout,
});

const form = useForm({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    accept_terms: false,
});

const submit = () => {
    form.post(route('register'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};
</script>

<template>
    <Head :title="$t('auth.create_account')" />

    <h1 class="mb-8 heading-1">{{ $t('auth.create_account') }}</h1>

    <form class="space-y-6" @submit.prevent="submit">
        <InputLabel :error="form.errors.email">
            <TextInput
                v-model="form.email"
                name="email"
                type="email"
                autocomplete="username"
                :placeholder="$t('auth.email')"
                :has-error="!!form.errors.email"
            />
        </InputLabel>

        <InputLabel :error="form.errors.password">
            <TextInput
                v-model="form.password"
                name="password"
                type="password"
                autocomplete="new-password"
                :placeholder="$t('auth.choose_your_password')"
                :has-error="!!form.errors.password"
            />
        </InputLabel>
        <InputLabel :error="form.errors.password_confirmation">
            <TextInput
                v-model="form.password_confirmation"
                name="password_confirmation"
                type="password"
                autocomplete="new-password"
                :placeholder="$t('auth.repeat_password')"
                :has-error="!!form.errors.password_confirmation"
            />
        </InputLabel>

        <div class="form-control">
            <label class="cursor-pointer label">
                <span class="label-text">
                    <i18n-t keypath="auth.accept_terms" scope="global">
                        <template #termsAndConditions>
                            <a href="/legal/terms_of_use.pdf" target="_blank" class="link link-primary">
                                {{ $t('labels.terms_and_conditions') }}
                            </a>
                        </template>
                        <template #privacyPolicy>
                            <a href="/legal/data_protection.pdf" target="_blank" class="link link-primary">
                                {{ $t('labels.privacy_policy') }}
                            </a>
                        </template>
                    </i18n-t>
                </span>
                <Checkbox
                    v-model:checked="form.accept_terms"
                    name="accept_terms"
                    class="checkbox-primary"
                    :has-error="!!form.errors.accept_terms"
                />
            </label>
            <div v-if="form.errors.accept_terms" class="label">
                <span class="label-text-alt text-error">
                    {{ form.errors.accept_terms }}
                </span>
            </div>
        </div>

        <button class="btn-block btn btn-primary" :disabled="form.processing">
            {{ $t('auth.register') }}
        </button>
    </form>

    <div class="mt-12 text-neutral">
        {{ $t('auth.already_registered') }}
        <Link :href="route('login')" class="link">
            {{ $t('auth.login_now') }}
        </Link>
    </div>
</template>
